import type {Auth0ClientOptions} from '@auth0/auth0-spa-js'

export const auth0Params = (() => {
  const auth0Params_: Auth0ClientOptions = {
    domain: process.env.AUTH0_ENDPOINT,
    client_id: process.env.AUTH0_CLIENT_ID,
    redirect_uri: typeof window !== 'undefined' ? window.location.origin : process.env.AMBLER_BO_URL,
    scope: 'openid email profile offline_access',
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    sessionCheckExpiryDays: 30,
  }

  if (typeof window !== 'undefined') {
    const queryParameterName = '__t'
    const sessionStorageKey = '@@amblea__42@@'
    const sessionStorageValue = window.sessionStorage.getItem(sessionStorageKey)
    const queryParameterValue = new URLSearchParams(window.location.search).get(queryParameterName)
    // * Required for new connect-as feature
    // * Override auth0 parameters to use sessionStorage for caching when:
    // * 1. The query parameter __t equals 42
    // * 2. When session storage key '@@amblea__42@@' exists
    if (sessionStorageValue || queryParameterValue === '42') {
      auth0Params_['cacheLocation'] = undefined
      auth0Params_['cache'] = {
        get: key => {
          const raw = sessionStorage.getItem(sessionStorageKey)
          const value = raw ? JSON.parse(raw) : {}
          return value[key]
        },
        set: (key, value) => {
          const raw = sessionStorage.getItem(sessionStorageKey)
          const current = raw ? JSON.parse(raw) : {}
          current[key] = value
          sessionStorage.setItem(sessionStorageKey, JSON.stringify(current))
        },
        remove: key => {
          const raw = sessionStorage.getItem(sessionStorageKey)
          const current = raw ? JSON.parse(raw) : {}
          delete current[key]
          sessionStorage.setItem(sessionStorageKey, JSON.stringify(current))
        },
        allKeys: () => {
          const raw = sessionStorage.getItem('__amblea_auth0')
          const value = raw ? JSON.parse(raw) : {}
          return Object.keys(value)
        },
      }
    }
  }

  return auth0Params_
})()
